export default {
  common: {
    save: 'Save',
    close: 'Close',
    cancel: 'Cancel',
    open: 'Open',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    delete: 'Delete',
    browse: 'Browse',
    ok: 'OK',
    view: 'View',
    load: 'Load',
    download: 'Download',
    manage: 'Manage',
    retrslt: 'Re-Process',
    retrsms: 'Re-Transmission',
    editmode: 'Edit Mode',
    viewmode: 'View Mode',
    select: 'Select',
    apply: 'Apply',
    error: 'Error',
    activate: 'Activate',
    tempSave: 'Temp Save',
    confirm: 'Confirm',
    collapseConditions: 'Collapse Search Conditions',
    expandConditions: 'Expand Search Conditions',
  },
  mapBuilder: {
    loadFromLocal: 'Load From Local',
    loadFromServer: 'Load From Server',
    scannerList: 'Scanner List',
    mapperList: 'Mapper List',
    compile: 'Compile',
    execute: 'Execute',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    selectCodeTable: 'Select Code Table',
    saveAs: 'Save As..',
    clear: 'Clear',
    clearAll: 'Clear All',
    checkedIn: 'Checked In',
    checkedOut: 'Checked Out',
  },
  codetable: {
    codeDataPool: 'CodeDataPool',
  },
  dbBroker: {
    queryPool: 'Query Pool',
  },
  mapManager: {
    checkIn: 'Check In',
    load: 'Load',
  },
  mappingDefiniton: {
    checkIn: 'Check In',
  },
  flatfileLayout: {
    checkIn: 'Check In',
  },
  customerDataAnalysis: {
    EDIFileUploadPopUp: {
      upload: 'Upload',
    },
  },
  repositoryMatching: {
    mergeLayout: 'Merge Layout',
    exeMatching: 'Execute Matching',
    moveSRMList: 'Move SRM List',
    statusRollback: 'Status Rollback',
    uploaded: 'Uploaded',
    layoutCreated: 'Layout Created',
    matchingProcessing: 'Matching Processing',
    matchingCompleted: 'Matching Completed',
    allCheck: 'All Check',
  },
  srmListManagement: {
    excel: 'Excel',
    total: 'Total :',
    browse: 'Browse',
  },
  developmentResourcesManagement: {},
  membership: {},
  company: {
    repository: 'Repository',
  },
  monitoring: {
    excel: 'Down Excel',
    originFiles: 'Down Origin Files',
    reMulti: 'Re-Process (Multiple)',
  },
  partners: {},
  identification: {},
  communications: {
    generate: 'Generate',
  },
  processSetup: {},
  repositoryManager: {
    repository: {
      compareMerge: 'Compare & Merge',
      saveRepository: 'Save Repository',
    },
    srmList: {
      copyRepository: 'Copy to Repository',
    },
  },
  integrationSET: {
    setUpSet: 'Go to Setup using this SET',
    downExcel: 'Down Excel',
    sampleData: 'Sample Data',
  },
  dataSource: {
    sqlGroup: 'SQL Group',
    dbConfig: 'DB Config',
    xmlMapper: 'XML Mapper',
    sqlGroupView: {
      queryPool: 'Query Pool',
    },
  },
  // 2022.05.20 213979 SLI-126 add button Xml Map Builder
  dbMapperTest: {
    xmlMapper: {
      list: 'List',
      save: 'Save',
      saveA: 'Save as..',
      test: 'Test',
      deploy: 'Deploy',
    },
  },
  //2022.06.02 213894 SLI-165 add button Xml Mapper
  xmlMapper: {
    sqlGroup: 'SQL Group',
  },
  dbConfig: {
    query: 'Query',
  },
  dbMapperManager: {
    checkIn: 'Check In',
  },
  userSimulator: {
    scriptList: 'Script List',
    validation: 'Validation',
    deploy: 'Deploy',
  },
};
